import { FC, ReactNode } from 'react';
import { Modal, ModalProps } from 'rsuite';
import { RsButton } from '../Button';
import { RsModalTrigger, RsModalTriggerProps } from './ModalTrigger';
import styles from './modal.module.scss';

interface RsConfirmationModalTriggerProps {
  renderModalTrigger: RsModalTriggerProps['renderModalTrigger'];
  message: ReactNode;
  onConfirm: (closeModal: () => void) => void;
  backdrop?: ModalProps['backdrop'];
}

export const RsConfirmationModalTrigger: FC<
  RsConfirmationModalTriggerProps
> = ({ renderModalTrigger, message, onConfirm, backdrop = true }) => {
  const renderModalContent = (closeModal) => {
    const handleConfirmation = () => {
      onConfirm(closeModal);
    };
    return (
      <>
        <Modal.Body>
          <div>{message}</div>
        </Modal.Body>
        <Modal.Footer className='flex justify-end gap-4'>
          <RsButton appearance='primary' onClick={handleConfirmation}>
            確認
          </RsButton>
          <RsButton appearance='ghost' onClick={closeModal}>
            取消
          </RsButton>
        </Modal.Footer>
      </>
    );
  };
  return (
    <RsModalTrigger
      className={styles.RsConfirmationModalTrigger}
      renderModalTrigger={renderModalTrigger}
      renderModalContent={renderModalContent}
      modalProps={{
        size: 'xs',
        backdrop,
      }}
    />
  );
};
